exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "._4u2mx3amsfukngfa564ddtj85awx2m7fvpwqrwusd2qdg332ywwvs8p876xn671zg7ht9ztqks8j5v2nkkfmth6qc457qx3bg9swugx-RegionSelect-module-regionSelectWrapper{min-width:120px;margin-left:20px}", "", {"version":3,"sources":["C:/a/_work/5/s/src/tables/components/RegionSelect/C:/a/_work/5/s/src/tables/components/RegionSelect/RegionSelect.module.scss"],"names":[],"mappings":"AAAA,kJACE,gBACA,gBAAiB,CAClB","file":"RegionSelect.module.scss","sourcesContent":[".regionSelectWrapper {\r\n  min-width: 120px;\r\n  margin-left: 20px;\r\n}\r\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"regionSelectWrapper": "_4u2mx3amsfukngfa564ddtj85awx2m7fvpwqrwusd2qdg332ywwvs8p876xn671zg7ht9ztqks8j5v2nkkfmth6qc457qx3bg9swugx-RegionSelect-module-regionSelectWrapper"
};